'use client';
import * as React from 'react';

/**
 * Context which enables deprecated bubbling to child navigators.
 */
export const DeprecatedNavigationInChildContext = React.createContext(false);
